import { render, staticRenderFns } from "./staticMarkdown.vue?vue&type=template&id=e585d5fe&"
import script from "./staticMarkdown.vue?vue&type=script&lang=js&"
export * from "./staticMarkdown.vue?vue&type=script&lang=js&"
import style0 from "./staticMarkdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports